import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    DashboardMgmtState,
    ReleaseGroup,
    CustomerAccount,
    Table,
    FetchTablesFilter
} from './types';
import { DashboardList } from 'store/dashboardViewer/types';

const initialState: DashboardMgmtState = {
    releaseGroups: [],
    releaseGroupSelected: 0,
    customerAccounts: [],
    customersSelected: [],
    customerLoader: false,
    dashboards: {
        items: [],
        totalCount: 0,
    },
    tables: {
        items: [],
        totalCount: 0,
        filter: {
            releaseGroupIds: []
        }
    },
    dashboardSelected: null,
    copyDashboardModal: {
        spinner: false,
        isOpen: false,
        dashboards: [],
        releaseGroups: [],
        releaseGroupSelected: 0,
        dashboardsSelected: [],
    },
    tableEditModal: {
        spinner: false,
        isOpen: false,
        title: '',
        dashboardTable: {
            id: 0,
            name: '',
            releaseGroupId: 0,
            sqlQuery: '',
            type: '',
            categoryId: 0,
            categoryName: '',
        }
    }
};

const dashboardMgmtSlice = createSlice({
    name: 'dashboardMgmt',
    initialState,
    reducers: {
        setReleaseGroups(state, action: PayloadAction<ReleaseGroup[]>) {
            state.releaseGroups = action.payload;
        },
        setCustomerAccounts(state, action: PayloadAction<CustomerAccount[]>) {
            state.customerAccounts = action.payload;
        },
        setCustomersSelected(state, action: PayloadAction<number[]>) {
            state.customersSelected = action.payload;
        },
        setReleaseGroupSelected(state, action: PayloadAction<number>) {
            state.releaseGroupSelected = action.payload;
        },
        setDashboardList(state, action: PayloadAction<DashboardList>) {
            state.dashboards = { ...action.payload };
        },
        setDashboardSelected(state, action: PayloadAction<number>) {
            state.dashboardSelected = action.payload;
        },
        changeCopyDashboardModal(state, action: PayloadAction<Partial<DashboardMgmtState['copyDashboardModal']>>) {
            state.copyDashboardModal = {
                ...state.copyDashboardModal,
                ...action.payload,
            };
        },
        closeCopyDashboardModal(state) {
            state.copyDashboardModal = { ...initialState.copyDashboardModal };
        },
        toggleCopyModalSpinner(state, action: PayloadAction<boolean>) {
            state.copyDashboardModal.spinner = action.payload;
        },
        toggleCustomerLoader(state) {
            state.customerLoader = !state.customerLoader
        },
        setTableList(state, action: PayloadAction<{ items: Table[]; totalCount: number; filter: Partial<FetchTablesFilter> }>) {
            state.tables = { ...action.payload };
        },
        changeTableEditModal(state, action: PayloadAction<Partial<DashboardMgmtState['tableEditModal']>>) {
            state.tableEditModal = { ...state.tableEditModal, ...action.payload, };
        },
        closeTableEditModal(state) {
            state.tableEditModal = { ...initialState.tableEditModal };
        },
        resetScreen() {
            return initialState;
        },
    },
});

export const actions = dashboardMgmtSlice.actions;
export default dashboardMgmtSlice.reducer;
